import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=d1898eaa"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=d1898eaa&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1898eaa')) {
      api.createRecord('d1898eaa', component.options)
    } else {
      api.reload('d1898eaa', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=d1898eaa", function () {
      api.rerender('d1898eaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/quote-by-product/inquiryQuotationProduct/detail.vue"
export default component.exports